module.exports = __webpack_public_path__ + "static/media/background.78d44189.svg";